import mongoose from "mongoose";

export interface EndCustomerExtended {
  _id: mongoose.Schema.Types.ObjectId;
  accountId: string;
  hasServiceDelivery: boolean;
  hasResellerSoldTo: boolean;
  hasResellerVendor: boolean;
  serviceDeliveryAccounts: string[];
  resellerSoldToAccounts: string[];
  resellerVendorAccounts: string[];
  serviceDeliveryPermissions: string[];
}

export const EndCustomerExtendedSchema = new mongoose.Schema<EndCustomerExtended>({
  accountId: { type: String, index: true, unique: true },
  hasServiceDelivery: Boolean,
  hasResellerSoldTo: Boolean,
  hasResellerVendor: Boolean,
  serviceDeliveryAccounts: [String],
  resellerSoldToAccounts: [String],
  resellerVendorAccounts: [String],
  serviceDeliveryPermissions: [String],
});
